import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { I_NormGroup } from '@Redux/search/interfaces';
import { setGroupListInfoM } from '@Redux/search/actions';
import { RootState } from '@Redux/search/store';
import ResultNoData from '@components/SearchPage/ResultNoData';
import getResultConditions from '@utils/getResultConditions';
import CardsList from './CardsList';
import styles from '../styles.module.scss';
import Spinner from '@components/Common/Spinner';

const M = () => {
    const search = useSelector((state: RootState) => state.search);
    const { GroupListInfoM, DepthInfo, FilterItems, SortListBy, TagFiltersShow, ChangeItem, Tags } =
        search;
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });
    const dispatch = useDispatch();

    const { data, isLoading, PageSize } = GroupListInfoM;

    const resultConditions = getResultConditions({
        FilterItems,
        DepthInfo,
        SortListBy,
        TagFiltersShow,
        search,
    });

    useEffect(() => {
        if (isMobile) {
            const reqBody = {
                ...resultConditions,
                Page: 1,
                PageSize: 10,
            };
            dispatch(setGroupListInfoM(reqBody));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, resultConditions.TripTypes, Tags]);

    useEffect(() => {
        if (ChangeItem) {
            if (isMobile) {
                const reqBody = {
                    ...resultConditions,
                    Page: 1,
                    PageSize: 10,
                };
                dispatch(setGroupListInfoM(reqBody));
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [FilterItems, DepthInfo, SortListBy, TagFiltersShow]);

    // 載入更多
    function loadingMorePage() {
        const reqBody = {
            ...resultConditions,
            Page: 1,
            PageSize: PageSize + 10,
        };
        dispatch(setGroupListInfoM(reqBody));
    }

    return (
        <>
            {/* if 點"更多精彩行程"按鈕，保留原本列表的高度
                else (更換搜尋條件)，只留下 Loading 圖 */}
            {(PageSize > 10 || !isLoading) &&
                data?.NormGroupList.map((item: I_NormGroup, i: number) => (
                    <CardsList key={i} groupData={item} />
                ))}
            {/* if Loading 完成且確實沒有資料，顯示"查無資料" */}
            {!isLoading && data?.NormGroupList.length === 0 && <ResultNoData />}
            {isLoading && <Spinner />}
            {/* if 正在 Loading 或 沒有更多資料了，則不顯示"更多精彩行程"按鈕 */}
            {isLoading || PageSize >= data!.TotalCount ? null : (
                <div className={styles.moreInfoWrapper}>
                    <div className={styles.moreInfo} onClick={loadingMorePage}>
                        更多精彩行程
                    </div>
                </div>
            )}
        </>
    );
};

export default M;
